import useTranslation from 'next-translate/useTranslation';

import styles from './ui.module.less';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface UiProps {}

export function Ui(props: UiProps) {
  const { t } = useTranslation('common');

  return (
    <div className={styles['container']}>
      <h1>{t('welcome_to_ui')}</h1>
    </div>
  );
}

export default Ui;
